import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
import { createBottomGradientCss, createTopGradientCss } from "./Gradient.styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* This component doesn't use local contexts because it can be directly imported from outside */
var Gradient = function Gradient(_ref) {
  var visibleUi = _ref.visibleUi,
    isMd = _ref.isMd;
  var topGradientCss = createTopGradientCss({
    visibleUi: visibleUi,
    isMd: isMd
  });
  var bottomGradientCss = createBottomGradientCss({
    visibleUi: visibleUi,
    isMd: isMd
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "cp-gradient tw-absolute tw-inset-0 tw-z-1",
    style: {
      mixBlendMode: 'multiply'
    },
    children: [/*#__PURE__*/_jsx(_StyledDiv, {
      className: "cp-top-gradient tw-absolute tw-top-0 tw-left-0 tw-w-full",
      $_css: topGradientCss
    }), /*#__PURE__*/_jsx(_StyledDiv2, {
      className: "cp-bottom-gradient tw-absolute tw-bottom-0 tw-left-0 tw-w-full",
      $_css2: bottomGradientCss
    })]
  });
};
export default Gradient;
var _StyledDiv = /*#__PURE__*/_styled("div")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  componentId: "sc-13llrzd-0"
})(["", ""], function (p) {
  return p.$_css2;
});